import api from './api';

export const getAttachments = () => api.get('/admin/attachments');

export const getAttachment = (id: number) => api.get(`/admin/attachments/${id}`);

export const createAttachment = (formData: FormData) =>
  api.post('/admin/attachments', formData);

export const updateAttachment = (id: number, formData: FormData) => {
  const file = formData.get('file');

  // Metadata-only edits: JSON PATCH avoids PHP multipart PUT parsing issues
  if (!(file instanceof File) || file.size === 0) {
    return api.patch(`/admin/attachments/${id}`, {
      name: formData.get('name'),
      email_category: formData.get('email_category') || null,
      case_type: formData.get('case_type') || null,
      case_state: formData.get('case_state') || null,
    });
  }

  // File replacement: multipart POST with Laravel method spoofing
  formData.append('_method', 'PUT');
  return api.post(`/admin/attachments/${id}`, formData);
};

export const deleteAttachment = (id: number) =>
  api.delete(`/admin/attachments/${id}`);

export const downloadAttachment = async (id: number) => {
  try {
    const response = await api.get(`/admin/attachments/${id}/download`, {
      responseType: 'blob',
    });

    const contentDisposition = response.headers['content-disposition'];
    let filename = 'attachment';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading attachment:', error);
    throw error;
  }
};
